var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Messages, Chat.11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7388",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7389",
    d: "M12.177 11.823a.25.25 0 11-.354 0 .25.25 0 01.354 0",
    fill: "none",
    stroke: "#0e6cae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7390",
    d: "M16.177 11.823a.25.25 0 11-.354 0 .25.25 0 01.354 0",
    fill: "none",
    stroke: "#0e6cae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7391",
    d: "M8.177 11.823a.25.25 0 11-.354 0 .25.25 0 01.354 0",
    fill: "none",
    stroke: "#0e6cae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7392",
    d: "M12 21h0a9 9 0 01-9-9h0a9 9 0 019-9h0a9 9 0 019 9h0a9 9 0 01-9 9z",
    fill: "none",
    stroke: "#0e6cae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgMenu;


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu.svg
// module id = 802
// module chunks = 101